import { useMutation } from '@apollo/client';
import { CREATE_MEMBER_OVERTIME_PERIOD, UPDATE_MEMBER_OVERTIME_PERIOD } from 'apollo/mutations/member-overtime-period';
import { DateTime } from 'luxon';
import OvertimePayRateType from 'types/enum/OvertimePayRateType';
import IMemberOvertimePeriodCreateInput from 'types/graphql/MemberOvertimePeriodCreateInput';
import IMemberOvertimePeriod, { IMemberOvertimePeriodUpdateInput } from 'types/MemberOvertimePeriod';

export default function useMemberOvertimePeriod() {
  const [createMemberOvertimePeriodMutation] =
    useMutation<{ createMemberOvertimePeriod: IMemberOvertimePeriod }>(CREATE_MEMBER_OVERTIME_PERIOD);
  const [updateMemberOvertimePeriodMutation] =
    useMutation<{ updateMemberOvertimePeriod: IMemberOvertimePeriod }>(UPDATE_MEMBER_OVERTIME_PERIOD);

  async function createMemberOvertimePeriod(
    memberId: string,
    changeDate: string,
    adhereToOrg: boolean,
    weeklyOvertime?: number | null,
    dailyOvertime?: number | null,
    dailyDoubletime?: number | null,
    seventhDayOvertime?: boolean | null,
    seventhDayDoubletime?: number | null,
    saturdayMultiplier?: OvertimePayRateType | null,
    sundayMultiplier?: OvertimePayRateType | null
  ) {
    const item: IMemberOvertimePeriodCreateInput = {
      memberId,
      changeDate,
      adhereToOrg,
      weeklyOvertime,
      dailyOvertime,
      dailyDoubletime,
      seventhDayOvertime,
      seventhDayDoubletime,
      saturdayMultiplier: saturdayMultiplier
        ? saturdayMultiplier === OvertimePayRateType.ONE_POINT_FIVE
          ? 1.5
          : 2.0
        : null,
      sundayMultiplier: sundayMultiplier ? (sundayMultiplier === OvertimePayRateType.ONE_POINT_FIVE ? 1.5 : 2.0) : null,
      createdOn: DateTime.utc().toISO().toString(),
    };

    return new Promise<IMemberOvertimePeriod>((resolve, reject) => {
      return createMemberOvertimePeriodMutation({ variables: { memberOvertimePeriod: item } }).then((results) => {
        if (results.data) {
          resolve(results.data.createMemberOvertimePeriod);
        } else {
          reject();
        }
      });
    });
  }

  function deleteMemberOvertimePeriod(memberOvertimePeriod: IMemberOvertimePeriod) {
    const item: IMemberOvertimePeriodUpdateInput = {
      id: memberOvertimePeriod.id,
      changeDate: memberOvertimePeriod.changeDate,
      adhereToOrg: memberOvertimePeriod.adhereToOrg,
      deletedOn: DateTime.utc().toISO(),
    };
    return updateMemberOvertimePeriodMutation({ variables: { memberOvertimePeriod: item } });
  }

  return { createMemberOvertimePeriod, deleteMemberOvertimePeriod };
}
